import authState from '@/modules/auth/store/state'
import constants from '@/util/constants'
export default class ContextManager {
  constructor (contextDefinitions) {
    this.contextDefinitions = contextDefinitions
  }

  getContextConfig (configName) {
    const hostname = window.location.host
    for (const context of this.contextDefinitions) {
      if (hostname.includes(context.domain)) {
        return context[configName]
      }
    }
    const contextConfigDefault = this.contextDefinitions[0][configName]
    return contextConfigDefault
  }

  handleApiPrefix = (url) => {
    const officeAdvDomain = process.env.VUE_APP_OFFICE_ADV_DOMAIN
    const mirtDomain = process.env.VUE_APP_MIRT_DOMAIN

    const contextMap = {
      [officeAdvDomain]: `${url}`,
      [mirtDomain]: `/manager/conta${url}`
    }

    const devMode = process.env.VUE_APP_DEV_MODE
    if (devMode) {
      const ehGestaoConta = authState.loginStrategy === constants.loginStrategy.managerLogin
      if (ehGestaoConta) {
        return contextMap[mirtDomain]
      }
      return contextMap[officeAdvDomain]
    }
    const hostname = window.location.host

    const matchedContext = Object.keys(contextMap).find((domain) => {
      return hostname.includes(domain)
    })

    const contextMapDefault = contextMap[officeAdvDomain]
    return matchedContext ? contextMap[matchedContext] : contextMapDefault
  }
}
